import styled from '@emotion/styled'
import { colors } from '../../shared/ui/colors'

export const MatrixWrapper = styled.div`
  background: ${colors.white};
  border-radius: 12px;
  border: 1px solid ${colors.gray300};
  overflow: hidden;
  padding: 21px;
`

export const MatrixContainer = styled.div`
  background: ${colors.white};
  border-radius: 12px;
  overflow: hidden;
  margin-top: 24px;
`



export const MatrixTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  border-style: hidden;
  table-layout: fixed;
  
  @media (max-width: 1024px) {
    display: none;
  }
`

export const TableHeader = styled.thead`
  th {
    padding: 12px 8px;
    text-align: center;
    font-weight: 600;
    color: ${colors.gray900};
    border-top: 1px solid ${colors.gray200};
    border-bottom: 1px solid ${colors.gray200};
    border-right: 1px solid ${colors.gray200};
    font-size: 14px;
    background: ${colors.white};
    height: 40px;
    
    &:first-of-type {
    border-top: 1px solid ${colors.black};
      background: ${colors.gray100};
      width: 60px !important;
      text-align: center;
      padding: 12px 0px;
      border-left: 4px solid ${colors.gray100};
      border-right: none;
      box-sizing: border-box;
      position: relative;
      font-size: .75rem;
      font-weight: 500;
      
      &::before {
        content: '';
        position: absolute;
        left: 4px;
        right: 0;
        top: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    
    &:nth-of-type(2) {
      text-align: left;
    }
    
    &:last-child {
      border-right: none;
      border-radius: 0 12px 0 0;
    }
  }
`

export const TableRow = styled.tr<{ level: number }>`
  border-bottom: 1px solid ${colors.gray200};
  height: 40px;
  
  &:first-of-type {
    border-top: 1px solid ${colors.gray50};
  }

  &:hover {
    background-color: ${colors.gray50};
  }
`

export const SectionCell = styled.td<{ level: number; isFirstColumn?: boolean }>`
  padding: 12px 8px;
  padding-left: ${({ level, isFirstColumn }) => isFirstColumn ? 4 : 24 + level * 24}px;
  padding-right: ${({ isFirstColumn }) => isFirstColumn ? 4 : 8}px;
  vertical-align: middle;
  background: ${({ isFirstColumn }) => isFirstColumn ? colors.gray100 : colors.white};
  border-right: ${({ isFirstColumn }) => isFirstColumn ? 'none' : '1px solid ' + colors.gray200};

  
  ${({ isFirstColumn, level }) => isFirstColumn ? `
    width: 60px !important;
    min-width: 60px;
    max-width: 60px;
    text-align: center;
    font-weight: bold;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-left: 4px solid ${level > 0 ? colors.gray400 : colors.black};
    box-sizing: border-box;
    padding-left: 6px;
    padding-right: 2px;
  ` : `
    width: auto;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0;
  `}
`

export const StatusCell = styled.td`
  padding: 8px;
  text-align: center;
  vertical-align: middle;
  background: ${colors.white};
  border-right: 1px solid ${colors.gray200};
  
  &:last-child {
    border-right: none;
  }
`

export const SectionNumber = styled.span<{ level: number }>`
  font-weight: 900;
  color: ${({ level }) => level > 0 ? colors.gray400 : colors.black};
  margin-right: 12px;
  font-size: 14px;
`

export const SectionTitle = styled.span`
  color: ${colors.gray900};
  font-size: 14px;
  font-weight: 600;
`

export const NestedArrow = styled.span`
  margin-right: 8px;
  color: ${colors.gray500};
  font-weight: 800;
  font-size: 14px;
  flex-shrink: 0;
  width: 16px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
`

export const SectionContentContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`

export const SectionTextBlock = styled.div`
  line-height: 1.4;
`

export const SubsectionRow = styled(TableRow)`
  background-color: ${colors.gray50};
`

// Карточная версия для мобильных устройств
export const CardsContainer = styled.div`
  display: none;
  padding: 0;
  gap: 16px;
  flex-direction: column;
  
  @media (max-width: 1024px) {
    display: flex;
    padding: 16px;
  }
`

export const SectionCard = styled.div<{ nested: boolean }>`
  background: ${colors.white};
  border: 1px solid ${colors.gray200};
  border-left: 4px solid ${({ nested }: { nested: boolean }) => nested ? colors.gray200 : colors.black};
  border-radius: 10px;
  padding: 16px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
  
  @media (max-width: 768px) {
    padding: 12px;
  }
`

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  gap: 8px;
`

export const CardSectionNumber = styled.span`
  padding: 3.5px 7px;
  flex: 28px 0;
  font-weight: 600;
  color: ${colors.gray700};
  font-size: 14px;
  background: ${colors.gray300};
  border-radius: 3.5px;
  text-align: center;
  font-size: 12px;
  font-weight: 500;
  border: 1px solid ${colors.gray400};
  
  @media (max-width: 768px) {
    font-size: 13px;
    min-width: 35px;
  }
`

export const CardSectionCode = styled.span`
  color: ${colors.gray700};
  font-size: 12px;
  font-weight: 400;
  background: ${colors.gray100};
  padding: 2px 6px;
  border-radius: 4px;
  margin-right: 8px;
  
  @media (max-width: 768px) {
    font-size: 11px;
    margin-right: 6px;
  }
`

export const CardSectionTitle = styled.span`
  color: ${colors.gray900};
  font-size: 14px;
  font-weight: 500;
  
  @media (max-width: 768px) {
    font-size: 13px;
  }
`

export const CardSectionIcon = styled.div`
  display: flex;
  align-items: center;
  font-weight: 800;
  font-size: 16px;
  color: ${colors.gray500};
  
  @media (max-width: 768px) {
    margin-left: 6px;
  }
`

export const CardTitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  flex: 1;
`

export const CardStatusContainer = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 8px;
  }
`

export const CardStatusGroup = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
`



export const CardStatusLabel = styled.div`
  font-size: 12px;
  color: ${colors.gray600};
  font-weight: 500;
  
  @media (max-width: 768px) {
    font-size: 11px;
  }
`
